import React, { useEffect, useState } from 'react';
import { Alert, Modal, Spin } from 'antd';
import api from '../services/api';
import { TrainingDocument } from '../types';
import { getApiErrorMessage } from '../utils/apiError';
import TranscriptEditor from './TranscriptEditor';

type Content = { html: string; text: string; revision: string };
const AdminTranscriptModal: React.FC<{ document: TrainingDocument; onClose: () => void; onSaved: () => Promise<void> }> = ({ document, onClose, onSaved }) => {
  const [content, setContent] = useState<Content | null>(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    let current = true;
    api.get<Content>(`/video/admin/documents/${document.id}/text`).then(({ data }) => { if (current) setContent(data); })
      .catch(err => { if (current) setError(getApiErrorMessage(err, 'Не удалось открыть транскрибацию')); });
    return () => { current = false; };
  }, [document.id]);
  return <Modal className="video-admin-modal video-admin-transcript-modal" title={`Редактировать текст: ${document.title}`} width={1000} open footer={null}
    onCancel={() => !saving && onClose()} closable={!saving} maskClosable={false} keyboard={!saving}>
    {error ? <Alert type="error" showIcon message={error} /> : !content ? <Spin tip="Загрузка текста…"><div style={{ minHeight: 120 }} /></Spin> :
      <TranscriptEditor html={content.html} onCancel={onClose} onSave={async html => {
        setSaving(true);
        try {
          const { data } = await api.patch<Content>(`/video/admin/documents/${document.id}/text`, { html, expected_revision: content.revision });
          setContent(data);
          await onSaved();
          onClose();
        } catch (err) { throw new Error(getApiErrorMessage(err, 'Не удалось сохранить текст')); }
        finally { setSaving(false); }
      }} />}
  </Modal>;
};

export default AdminTranscriptModal;
